import { Checkbox, Form } from 'antd';
import { useIntl } from 'react-intl';

export default function ReportWorkOrderSyntheticCheckbox() {
  const intl = useIntl();

  return (
    <Form.Item
      noStyle
      name="isSynthetic"
      initialValue={false}
      valuePropName="checked"
    >
      <Checkbox>
        {intl.formatMessage({
          id: 'movementWorkOrdersReport.form.synthetic',
        })}
      </Checkbox>
    </Form.Item>
  );
}
